<template>
  <div
    v-if="isItinerary || !eventGetters.getHasMultipleLocations(kftEvent)"
    class="location-info my-10"
    :class="{
      'location-info--full-width': isFullWidth,
    }"
  >
    <template v-if="eventGetters.getAttendanceMode(kftEvent) !== 'ONLINE'">
      <ClientOnly fallback-tag="span" fallback="Loading location map...">
        <TapToRemoveOverlay>
          <MapWidget
            :points="getRoutes"
            :is-route-visible="isItinerary"
            :is-map-visible="!eventGetters.getHasMultipleLocations(kftEvent)"
          />
        </TapToRemoveOverlay>
      </ClientOnly>
    </template>

    <!-- this is visible only on default events -->
    <LocationInfo
      v-if="!isItinerary"
      :title="
        eventGetters.getHasMobileClasses(kftEvent)
          ? $t('product.show.map.addressMobileClass')
          : getTitleByCategory('location', kftEvent)
      "
      :subtitle="`${eventGetters.getTitle(kftEvent)} - ${
        eventGetters.getAttendanceMode(kftEvent) === 'ONLINE'
          ? $t('general.online')
          : eventGetters.getFormattedAddress(kftEvent)
      }`"
    />
  </div>
</template>

<script setup lang="ts">
import { useTitleByCategory } from '~/composables/product/useGetTitleByCategory'

const { t: $t } = useI18n()

const props = withDefaults(
  defineProps<{
    kftEvent: object
  }>(),
  {
    kftEvent: () => ({}),
  }
)
const { getTitleByCategory } = useTitleByCategory()

const isItinerary = computed(() => {
  return props.kftEvent?.itinerary?.length > 0
})

const isFullWidth = computed(() => {
  return (
    isItinerary.value && !eventGetters.getHasMultipleLocations(props.kftEvent)
  )
})

const getRoutes = computed(() => {
  if (!props.kftEvent.itinerary) return [coordinates.value]

  return props.kftEvent.itinerary
})

const coordinates = computed(() => {
  const latLng = eventGetters.getCoordinates(props.kftEvent)

  return {
    lat: latLng?.[0] || 0,
    lng: latLng?.[1] || 0,
  }
})
</script>

<style lang="postcss" scoped>
.location-info {
  @apply p-3 bg-[#FCFBFA] relative z-1 rounded-lg;

  &--full-width {
    @apply overflow-hidden md:overflow-visible;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      bottom: 0;
      left: -9999px;
      right: -9999px;
      background: #fcfbfa;
      z-index: -1;
    }

    display: flex;
  }

  &:not(&--full-width) {
    max-width: 812px;
  }
}
</style>
